export default __webpack_public_path__ + "static/media/about-logo.ecee5c4b.png";